import request from './request'

// 登录接口：POST /user/login
// 参数名需严格保持 userName 和 passWord
// 使用 form-data 格式传参
export function loginApi({ userName, passWord }) {
  const formData = new FormData()
  formData.append('userName', userName)
  formData.append('passWord', passWord)
  
  return request({
    url: '/user/login',
    method: 'post',
    data: formData,
    // 不手动设置 Content-Type，交由浏览器自动生成带 boundary 的 multipart/form-data 头
  })
}